export default __webpack_public_path__ + "static/media/antelopeKlein.436c5a7e.jpg";